<br />
<!-- {{ values$()| json}} -->
<div *ngFor="let formControl of values$(); let i= index" class="warp">
    <ng-container *ngIf="itemTemplate">
        <div *ngTemplateOutlet="itemTemplate;context:{index: i,control: formControl}"></div>
    </ng-container>
    <!-- <ng-container *ngIf="removeBtnTemplate">
        <div *ngTemplateOutlet="removeBtnTemplate;context:{index: i}"></div>
    </ng-container> -->
    <!-- <button mat-raised-button color="accent" (click)="remove(i)">Remove</button> -->
</div>
<ng-container *ngIf="addBtnTemplate">
    <div (click)="add()">
        <ng-container *ngTemplateOutlet="addBtnTemplate"></ng-container>
    </div>
</ng-container>
<!-- <button mat-raised-button color="primary" (click)="add()">Add</button> -->